import axios from "axios";

const BASE = "http://127.0.0.1:8000/api/patients/admissions/";

function unwrapResponse(res) {
  const data = res?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;
  return data ?? [];
}

export async function listAdmissions() {
  const res = await axios.get(`${BASE}?format=json`);
  return unwrapResponse(res);
}

export async function updateAdmission(admissionId, payload) {
  const res = await axios.patch(`${BASE}${admissionId}/?format=json`, payload);
  return res?.data;
}

export async function deleteAdmission(admissionId) {
  const res = await axios.delete(`${BASE}${admissionId}/?format=json`);
  return res?.data;
}

export async function getAdmissionById(admissionId) {
  const res = await axios.get(`${BASE}${admissionId}/?format=json`);
  return res?.data;
}